import React, { useEffect, useRef, useState } from 'react';
import '../../css/privacy.css';
import { postAsync } from '../../utils/httpClient';
import { CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';

// 개인정보 처리방침 페이지
const PrivacyTerms = () => {
  const renderRef = useRef(true);
  const [privacyTerms, setPrivacyTerms] = useState();
  const [privacyTermsList, setPrivacyTermsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (renderRef.current) {
      renderRef.current = false; // 첫 렌더링 이후에는 두번 호출되지 않도록 설정
      postAsync('/v2/terms/serviceAll/1',{})
        .then((res) => {
          if(res.message === "success"){
            const responseList = res.data.docs;
            setPrivacyTerms(responseList.shift());
            setPrivacyTermsList(responseList);
          } else {
            throw new Error(res.message);
          }
          setLoading(false);
        })
        .catch((error) => {
          alert("개인정보 처리방침 조회 중 오류가 발생했습니다.")
          console.error("Error:", error);
          navigate('/',{replace:true});
        });
    }
  }, [navigate]);

  return (
    <div className={"wrapper"} style={{ height: loading ? '100vh' : 'auto' }}>
        {/* 제목 */}
        <h2 className={"title"}>
          {privacyTerms?.termsTitle}
        </h2>

        {/* 내용 */}
        <div className={"contents"}
          style={{
            display: loading ? 'flex' : 'block',
            justifyContent: loading ? 'center' : 'unset',
          }}
        >
          {loading ? (  // 로딩 상태일때  mui 로딩 스피너 (api의 데이터가 불러오기전까지 로딩상태 설정)
            <CircularProgress color="inherit" />
          ) : (
            (<div dangerouslySetInnerHTML={{__html: privacyTerms?.termsContents}}/>)
          )}
        </div>

        {/* 이전 버전 이용약관 리스트 */}
        {privacyTermsList.length > 0 && (
          <div className="log">
            <p className="logTitle">과거 개인정보 처리방침은 아래 내용을 확인하시길 바랍니다.</p>
            {privacyTermsList.map((termsData, index)=>{
              return (
                <label htmlFor={`terms_${index}`} className="logText" style={{color:termsData._id === privacyTerms?._id ? "#6b6b6b":"#0000EE"}}>
                  {`이전 개인정보 처리방침 ${termsData.termsDate}`}
                  <button
                    id={`terms_${index}`}
                    hidden
                    onClick={()=>{
                      setPrivacyTerms(termsData);
                      window.scrollTo(0,0);
                    }}
                  />
                </label>
              )
            })}
          </div>
        )}
    </div>
  );
}

export default PrivacyTerms;
